/** update `RgObject` properties based on the `modulousId` */
function setModulousId({ obj, modulousId, rvDataList }) {
    obj.modulousId = modulousId;
    const rvData = rvDataList.find(d => d.modulousId === obj.modulousId);
    // replace data from the default creator if its found in RvData
    if (rvData) {
        if (rvData.size) {
            for (let i = 0; i < 3; i++) {
                if (!rvData.size[i])
                    continue;
                obj.size[i] = rvData.size[i];
            }
        }
        if (rvData.color) {
            obj.color = rvData.color;
        }
    }
    return obj;
}

export { setModulousId };
//# sourceMappingURL=set-modulous-id.js.map
